export enum VARIANTS {
  'white' = 'white',
  'black' = 'black',
  'max' = 'max',
  'dark' = 'dark',
  'light' = 'light',
  'lighter' = 'lighter',
  'min' = 'min',
  'primary' = 'primary',
  'secondary' = 'secondary',
  'info' = 'info',
  'positive' = 'positive',
  'negative' = 'negative',
  'warning' = 'warning',
  'panda' = 'panda',
  'pandaDark' = 'pandaDark',
  'flamingo' = 'flamingo',
  'cocodrile' = 'cocodrile',
  'pig' = 'pig',
  'koala' = 'koala',
  'parrot' = 'parrot',
  'parrotLight' = 'parrotLight',
  'octupus' = 'octupus',
}
